import { useCallback, useEffect, useState } from "react";
import { fetchFounderCommunityDashboard, FounderCommunityDashboard } from "../services/founderCommunityService";

type FounderCommunityState = {
  data: FounderCommunityDashboard | null;
  error: string | null;
  isLoading: boolean;
  lastUpdated: Date | null;
  refresh: () => Promise<void>;
};

export function useFounderCommunity(): FounderCommunityState {
  const [data, setData] = useState<FounderCommunityDashboard | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);

  const refresh = useCallback(async () => {
    setIsLoading(true);

    try {
      const result = await fetchFounderCommunityDashboard();
      setData(result);
      setError(result.error);
      setLastUpdated(result.lastUpdated);
    } catch {
      setData(null);
      setError("Unable to load Founder Community.");
      setLastUpdated(new Date());
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    data,
    error,
    isLoading,
    lastUpdated,
    refresh
  };
}
